import React, { useContext } from 'react';
import Honeybadger from 'honeybadger-js';
import {
  PagesFragment,
  HeadlineItemsFragment,
  useCreateHeadlineItemMutation,
  useUpdatePageMutation,
} from '../generated/graphql';
import { TrackingContext } from '../TrackingContext';
import addItemToPage from './apolloCache/addItemToPage';
import { pagesQuery } from '../components/LeftContainer/graphql';

const useComingSoonPage = (page: PagesFragment) => {
  const { track } = useContext(TrackingContext);
  const [create] = useCreateHeadlineItemMutation();
  const [updatePage] = useUpdatePageMutation();
  const pageId = page.id;
  const title = `${page.title} coming soon!`;

  const makePageVisisble = async () => {
    try {
      const { data } = await updatePage({
        variables: {
          id: page.id as number,
          attributes: { show: true },
        },
      });
      track('WWS Page Edited', {
        pageType: data?.updatePage?.type,
        action: 'edit',
        actionName: 'visibility',
        pageVisible: data?.updatePage?.show,
        page: data?.updatePage?.title,
        source: 'guidance',
      });
    } catch (error) {
      Honeybadger.notify(error, {
        message: 'Error updating page',
        context: {
          error,
        },
      });
    }
  };

  const addComingSoon = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    if (!page.show) {
      await makePageVisisble();
    }

    try {
      await create({
        variables: {
          attributes: {
            pageId,
            title,
            style: 'large',
          },
        },
        update: (cache, { data }) => {
          track('Item Added', {
            action: 'add',
            actionName: 'Add Page Item',
            page: page.title,
            item: 'coming soon',
            source: 'guidance',
          });
          addItemToPage<HeadlineItemsFragment | undefined>(cache, pageId, data?.createHeadlineItem);
        },
        refetchQueries: [{ query: pagesQuery }],
      });
    } catch (error) {
      Honeybadger.notify(error, {
        message: 'Error creating coming soon title',
        context: {
          error,
        },
      });
    }
  };

  return addComingSoon;
};

export default useComingSoonPage;
